export const CompassConfig = {
    RenderConfig: {
        width: 120,
        height: 120,
        cameraPositionZ: 11.5,
    },
    cameraConfig: {
        fov: 45, // filed of view
    },
    transparentOpacity: 0.3,
    solidOpacity: 1,
    cubeSize: 5,
    canvasWidth: 128,
    canvasHeight: 128,
    cubeColor: "#54534F",
    cubeFont: "bold 28px Arial",
    textColor: "#FFFFFF",
};

/* ** DO NOT CHANGE ** */
// This is in the exact order so as to match the compass cube.
export const CompassLabels = ["RIGHT", "LEFT", "TOP", "BOTTOM", "FRONT", "BACK"];
